export default {
  meta: {
    title: '生成图片首页'
  }
};
